import {BehaviorSubject} from 'rxjs';

export class SearchList {

  search: any[] = [];

  startIndex: number;
  pageHits: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalHits: number;

  error: string = '';

  constructor(attr: { search?: any[], startIndex?: number, pageHits?: number, pageNumber?: number, pageSize?: number, totalPages?: number, totalHits?: number, error?: string } = {},
              private maxResultWindow: number ) {

    this.search = attr.search;


    this.startIndex = attr.startIndex;
    this.pageHits = attr.pageHits;
    this.pageNumber = attr.pageNumber + 1; // we count from 1
    this.pageSize = attr.pageSize;
    this.totalPages = this.limitTotalPages(attr.totalPages, this.pageSize);
    this.totalHits = attr.totalHits;

    if (attr.error) {
      this.error = attr.error;
    }

    this.startIndex = ((this.pageNumber - 1) * this.pageSize) + 1;
  }

  public isError(): boolean {
    return (this.error && this.error.length > 0);
  }

  private limitTotalPages(totalPages: number, pageSize: number): number{
    if(totalPages * pageSize > this.maxResultWindow){
      return Math.floor(this.maxResultWindow/pageSize);
    }
    return totalPages;
  }

}
